export const replaceRouteParam = (route: string, paramName: string, paramValue: string) => {
    return route.replace(`:${paramName}`, paramValue);
};
